// removed by extract-text-webpack-plugin
module.exports = {"active":"app-pages-Customers-Loyalty-Components-Program-ProgramType-__ProgramType___3JVYU","action-label":"app-pages-Customers-Loyalty-Components-Program-ProgramType-__ProgramType___3XUZU","disabled":"app-pages-Customers-Loyalty-Components-Program-ProgramType-__ProgramType___3s9Jb","program":"app-pages-Customers-Loyalty-Components-Program-ProgramType-__ProgramType___2PElP"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/Loyalty/Components/Program/ProgramType/ProgramType.css
// module id = 2313
// module chunks = 0